import Swiper from 'swiper/dist/js/swiper.js';

var deviceSwiper = new Swiper('.hp-device__swiper-container', {
  speed: 200,
  spaceBetween: 0,
  touchReleaseOnEdges: true,
  autoplay: {
    delay: 8000,
    disableOnInteraction: false
  },
  loop: true,
  navigation: {
    nextEl: '.hp-device__swiper-next',
    prevEl: '.hp-device__swiper-prev',
  },
});

deviceSwiper.on('slideNextTransitionStart', function(){
  deviceSwiper.navigation.$nextEl.addClass('hp-device__swiper-next--active');
});

deviceSwiper.on('slidePrevTransitionStart', function(){
  deviceSwiper.navigation.$prevEl.addClass('hp-device__swiper-prev--active');
});

deviceSwiper.on('slideChangeTransitionEnd', function(){
  deviceSwiper.navigation.$nextEl.removeClass('hp-device__swiper-next--active');
  deviceSwiper.navigation.$prevEl.removeClass('hp-device__swiper-prev--active');
});

$(function(){

  if ($('.js_device-img').length > 0) {
    deviceSwiper.autoplay.stop();
    var interval = setInterval(function(){
      var images = document.body.getElementsByClassName('js_device-img');
      var length = images.length;
      var counter = 0;
      for (var i = 0; i < length; i++) {
        if (images[i].complete) {
          counter++;
        }
      }
      if (counter === length) {
        $('.js_device').addClass('animate');
        deviceSwiper.autoplay.start();
        clearInterval(interval);
      }
    }, 800);
  }

});

let bubblesBg = document.getElementsByClassName('js_bubbles-bg');
deviceSwiper.on('slideChange', function () {
  for (let i = 0; i < bubblesBg.length; i++) {
    bubblesBg[i].classList.remove('hp-device__bubbles-bg--active');
  }
  bubblesBg[deviceSwiper.realIndex].classList.add('hp-device__bubbles-bg--active');
});


// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/landingDevice.js